import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { Unit } from '@silbo/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type UnitFilterDialogProps = {
  open: boolean;
  units: Unit[];
  selectedUnitIds: string[];
  onClose: () => void;
  onApply: (unitIds: string[]) => void;
};

const toggle = (ids: string[], id: string) => (ids.includes(id) ? ids.filter((item) => item !== id) : [...ids, id]);

const UnitFilterDialog = ({ open, units, selectedUnitIds, onClose, onApply }: UnitFilterDialogProps) => {
  const { t } = useTranslation('environmental-cleaning');
  const [draft, setDraft] = useState(selectedUnitIds);

  const apply = () => {
    onApply(draft);
    onClose();
  };

  const clear = () => {
    onApply([]);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        <Typography variant="h2">{t('missions.unitFilter.title')}</Typography>
      </DialogTitle>
      <DialogContent>
        <List disablePadding>
          {units.map((unit) => (
            <ListItemButton key={unit.id} onClick={() => setDraft(toggle(draft, unit.id))}>
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={draft.includes(unit.id)}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': `unit-filter-${unit.id}` }}
                />
              </ListItemIcon>
              <ListItemText id={`unit-filter-${unit.id}`} primary={unit.name} />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={clear}>
          {t('missions.unitFilter.clear')}
        </Button>
        <Button onClick={apply}>{t('missions.unitFilter.apply')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnitFilterDialog;
